import { OktaAuth } from '@okta/okta-auth-js';

/**
 * Read environment variables.
 * (These must all start with REACT_APP_ in your .env file!)
 */
const {
    REACT_APP_CLIENT_ID,
    REACT_APP_ISSUER,
    REACT_APP_REDIRECT_URI,
    REACT_APP_POST_REDIRECT_URI,
} = process.env;

/**
 * Optional: create readable aliases
 */
const clientId = REACT_APP_CLIENT_ID;
const issuer = REACT_APP_ISSUER;
const redirectUri = REACT_APP_REDIRECT_URI;
const postLogoutRedirectUri =
    REACT_APP_POST_REDIRECT_URI || window.location.origin + '/login';

/**
 * Validate that required values exist.
 * This throws a clear message early if any env var is missing.
 */
if (!issuer) {
    throw new Error(
        'Missing REACT_APP_ISSUER in environment variables. Example:\n' +
        'REACT_APP_ISSUER=https://dev-123456.okta.com/oauth2/default'
    );
}
if (!clientId) {
    throw new Error(
        'Missing REACT_APP_CLIENT_ID in environment variables. Example:\n' +
        'REACT_APP_CLIENT_ID=0oa123example'
    );
}
if (!redirectUri) {
    throw new Error(
        'Missing REACT_APP_REDIRECT_URI in environment variables. Example:\n' +
        'REACT_APP_REDIRECT_URI=http://localhost:3000/login/callback'
    );
}

/**
 * Instantiate the OktaAuth SDK
 * pkce: true  → PKCE flow (recommended)
 * scopes: include "offline_access" so you can silently renew tokens
 */
const oktaAuth = new OktaAuth({
    issuer, 
    clientId,
    redirectUri,
    postLogoutRedirectUri,
    pkce: true,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
});

/**
 * Export the single shared instance.
 * This is imported by your interceptor and <Security> component.
 */
export default oktaAuth;
